module.exports = __webpack_public_path__ + "static/media/GutHowItWorks3.416f86f8.png";